import {
    CreateCategoryAndSubcategory,
    CreateEquipmentImage,
    GetCategoryAndSubcategory,
} from '../../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { base64ToFile } from '../../../../../utils/Base64ToBlob';
import { CATEGORY_TYPE } from './../../../../../pages/Dashboard/Contractors/EquipmentAndMaterial/Model/Model';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

export const uploadEquipmentImage = async ({ equipmentId, fileSelected = null, selfieSrc = null, dispatch }) => {
    const formData = new FormData();
    formData.append('fileUploadDto.files', fileSelected);
    formData.append('id', equipmentId);
    formData.append('fileUploadDto.userFileNames', fileSelected.name);
    formData.append('storageType', 0);

    await dispatch(CreateEquipmentImage(formData));
};

// Base body for creating a subcategory
export const getCreateSubcategoryBody = (contractorId) => ({
    type: CATEGORY_TYPE.SUBCATEGORY,
    contractorId,
});

// Base body for creating a category
export const getCreateCategoryBody = (contractorId) => ({
    type: CATEGORY_TYPE.CATEGORY,
    contractorId,
});

// Create category or subcategory
export const createCategoryOrSubcategory = async ({ body, contractorId, dispatch, onSuccess, onError }) => {
    const { payload } = await dispatch(CreateCategoryAndSubcategory(body));
    const {
        data: { data, success, code },
    } = payload;

    if (success === true) {
        onSuccess?.();

        dispatch(
            GetCategoryAndSubcategory({
                userId: contractorId,
                model: body.type,
            }),
        );

        return data;
    }

    onError?.(code);
    throw new Error(code);
};

// Search subcategories
export const searchSubcategories = async ({ key, contractorId, dispatch }) => {
    const { payload } = await dispatch(
        GetCategoryAndSubcategory({
            userId: contractorId,
            model: CATEGORY_TYPE.SUBCATEGORY,
            key,
        }),
    );

    return payload?.data?.data || [];
};

// Search categories
export const searchCategories = async ({ key, contractorId, dispatch }) => {
    const { payload } = await dispatch(
        GetCategoryAndSubcategory({
            userId: contractorId,
            model: CATEGORY_TYPE.CATEGORY,
            key,
        }),
    );

    return payload?.data?.data || [];
};

/**
 * Returns a keyDown handler for CustomChipAutocomplete that allows
 * creating a new item when pressing Enter.
 *
 * @param {Object} params
 * @param {Object} params.createBody - Base body used to create the item
 * @param {Function} params.onCreate - Function that performs the create action
 * @param {Array} params.value - Current selected autocomplete values
 * @param {Function} params.onChange - Setter for the selected values
 * @returns {Function} onKeyDown handler
 */
export const handleAutocompleteKeyDown =
    ({ createBody, onCreate, value = [], onChange, t }) =>
    async (event) => {
        if (event.key !== 'Enter') return;

        const inputValue = event.target.value?.trim();
        if (!inputValue) return;

        event.preventDefault();

        try {
            // Create the new item using the provided body and name
            const newItem = await onCreate({
                ...createBody,
                name: inputValue,
            });

            if (!newItem) return;

            // Append the newly created item to the current selection
            onChange([
                ...(value || []),
                {
                    ...newItem,
                    label: newItem.label ?? newItem.name ?? inputValue,
                },
            ]);
            event.target.value = '';
        } catch (error) {}
    };
